import PropTypes from 'prop-types'
import styled from 'styled-components'
import buttonHorizontalCSS from './button-horizontal.css'
import buttonVerticalCSS from './button-vertical.css'
import buttonCSS from './button.css'

const NewPill = styled.img`
    position: absolute;
    display: inline-block;
    height: 20px;
    top: 10px;
    right: 10px;
}
`

const getIcon = (css, type) => {
    switch (type) {
        case 'video':
            return css.iconVideo
        case 'photo':
            return css.iconPhoto
        case 'supercut':
            return css.iconSuperCut
        case 'browse':
            return css.iconBrowse
        case 'drag':
            return css.iconDrag
        case 'backdrop':
            return css.iconBackdrop
        default:
            return css.iconWebcam
    }
}

const getCSS = isVertical =>
    isVertical ? { ...buttonCSS, ...buttonVerticalCSS } : { ...buttonCSS, ...buttonHorizontalCSS }

const FilePortalInputButton = ({ label, description, icon, isVertical, isNew = false }) => {
    const css = getCSS(isVertical)
    return (
        <div className={css.container}>
            <div className={getIcon(css, icon)} />
            <div className={css.copyContainer}>
                <div className={css.subtitle}>{label}</div>
                <span className={css.description}>{description}</span>
            </div>

            {isNew && <NewPill src="/static/img/svg/pill-new.svg" alt="" />}
        </div>
    )
}

FilePortalInputButton.propTypes = {
    label: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    isVertical: PropTypes.bool.isRequired,
}

export default FilePortalInputButton
